import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onBeforeUnmount, ref } from 'vue';
import L from 'leaflet';


export default /*@__PURE__*/_defineComponent({
  __name: 'TrafficLayer',
  props: {
    map: {}
  },
  setup(__props: any) {

const props = __props;

let trafficLayer: any = null;

const addTrafficLayer = () => {
    if (!props.map) {
        console.warn('[TrafficLayer] Missing map');
        return;
    }

    const url = `/proxy/tomtom-tiles/flow/relative/{z}/{x}/{y}.png`;

    trafficLayer = L.tileLayer(url, {
        tileSize: 512,
        zoomOffset: -1,
        maxZoom: 18,
        attribution: '&copy; <a href="https://www.tomtom.com/">TomTom</a>',
        opacity: 0.7,
        zIndex: 200
    });

    trafficLayer.addTo(props.map);
    console.log('[TrafficLayer] Traffic layer added');
};

onMounted(() => {
    addTrafficLayer();
});

onBeforeUnmount(() => {
    if (trafficLayer) {
        trafficLayer.remove();
        trafficLayer = null;
        console.log('[TrafficLayer] Traffic layer removed');
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})